import Vue from "vue";
import { mapGetters } from "vuex";
import router from "../router";
import LocalStorageService from "@/common/LocalStorageService";

// Global Mixin
Vue.mixin({
  data() {
    return {
      cancelRequest: null
    };
  },
  computed: {
    ...mapGetters(["isFullAccess", "profile"]),
    isAdmin() {
      let profile = { ...this.profile };
      if (profile) {
        const { listRoles } = profile;
        for (const item of listRoles) {
          if (item?.name?.toLowerCase() == "admin") return true;
        }
      }
      return false;
    },
    isAdminOrPV() {
      let profile = { ...this.profile };
      if (profile) {
        const { listRoles } = profile;
        for (const item of listRoles) {
          const name = item.name?.toLowerCase();
          if (name == "print_vendor" || name == "admin") return true;
        }
      }
      return false;
    },
    buttonSize() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    }
  },
  methods: {
    async downloadTemplate(URL_TEMPLATE, NAME_TEMPLATE, TYPE = "force") {
      const link = document.createElement("a");
      if (TYPE == "force") {
        link.href = URL_TEMPLATE;
      } else {
        let blob = await fetch(URL_TEMPLATE).then(r => r.blob());
        const url = window.URL.createObjectURL(blob);
        link.href = url;
      }
      link.setAttribute("download", NAME_TEMPLATE);
      document.body.appendChild(link);
      link.click();
    },
    letterKeydown(e) {
      if (
        e.keyCode == 69 ||
        e.keyCode == 187 ||
        e.keyCode == 188 ||
        e.keyCode == 189 ||
        e.keyCode == 190
      ) {
        e.preventDefault();
      }
    },
    letterDecimal(e) {
      if (
        e.keyCode == 69 ||
        e.keyCode == 187 ||
        e.keyCode == 188 ||
        e.keyCode == 189
      ) {
        e.preventDefault();
      }
    },
    getToPage(routeName, params, type = "push") {
      router[type]({ name: routeName, ...params });
    },
    cancelReq() {
      this.cancelRequest && this.cancelRequest.cancel("Cancel");
    },
    createToken(callback) {
      callback && (this.cancelRequest = callback);
    },
    debounce(callback, delay = 500) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        callback();
      }, delay);
    },
    fetchListDebounce(callback, delay = 500) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        callback();
      }, delay);
      this.cancelRequest && this.cancelReq();
    },
    fetchThrottle(functionToCall, limit = 200) {
      // Initially we want to call the `functionToCall`
      // Hence default value is set to true.
      let hasIntervalPassed = true;
      return function(...arg) {
        const context = this;
        const args = arg;
        // Once the function is called,
        // we now want to block the function call & set the limit
        if (hasIntervalPassed) {
          // We're using `apply` because
          // 1] It can access context
          // 2] Multiple arguments can be passed easily.
          functionToCall.apply(context, args);
          hasIntervalPassed = false;
        }
        setTimeout(function() {
          // Once the interval has passed,
          // we want to allow `functionToCall` to be called.
          hasIntervalPassed = true;
        }, limit);
      };

      // Let's assume our button has id `my-custom-button`
      // const myButton = document.getElementById("my-custom-button");
      // function buttonClick(event) {
      //   handle api call here
      // }
      // myButton.addEventListener(
      //   "click",
      //   throttle(function(event) {
      //     buttonClick(event);
      //   }, 500)
      // );
    },
    setNextDay(dateBefore, dateAfter) {
      // add 1 day when date is same
      // console.log("date Before : ", dateBefore, " \n date After : ", dateAfter);
      let date = dateAfter ? this.$moment(dateAfter).valueOf() : null;
      if (
        (dateBefore || dateAfter) &&
        this.$moment(dateBefore).isSame(dateAfter)
      ) {
        date = this.$moment(dateAfter)
          .add(1, "days")
          .valueOf();
      }
      return date;
    },
    addLastMinute(dateAfter) {
      if (!dateAfter) return dateAfter;

      return this.$moment(dateAfter)
        .add(23, "hours")
        .add(59, "minutes")
        .add(59, "seconds")
        .valueOf();
    },

    addOneDay(_dateBefore, dateAfter) {
      // add 1 day when date is same

      return dateAfter
        ? this.$moment(dateAfter)
            .add(1, "days")
            .valueOf()
        : null;
    },
    getUsername() {
      return LocalStorageService.getUsername();
    },
    getUserProfile() {
      return JSON.parse(LocalStorageService.getProfile());
    },
    convertingNull(param) {
      param.map(item => {
        item.rateRegular == "0" ||
          (item.rateRegular == "" && (item.rateRegular = null));
        item.rateRepeat == "0" ||
          (item.rateRepeat == "" && (item.rateRepeat = null));
        item.storeSubsidy == "0" ||
          (item.storeSubsidy == "" && (item.storeSubsidy = null));
        item.fifIncome == "0" ||
          (item.fifIncome == "" && (item.fifIncome = null));
        item.storeAdminFee == "0" ||
          (item.storeAdminFee == "" && (item.storeAdminFee = null));
      });
      return param;
    }
  }
});
